export enum TypeFiles {
  csv = 'csv',
  text = 'txt',
  json = 'json',
}

export enum TypeOperations {
  out = 'Withdrawal',
  in = 'Deposit',
}

export enum TypeOperationsApp {
  OUT = 'Partner',
  IN = 'Customers ',
}

export enum BatchStatus {
  created = 'CREATED',
  error = 'ERROR',
  sent = 'SENT',
  completed = 'COMPLETED',
  pending = 'PENDING',
  rejected = 'REJECTED',
  all = 'all'
}

export enum TypeStatus {
  created = 'CREATED',
  error = 'ERROR',
  sent = 'SENT',
  completed = 'COMPLETED',
  pending = 'PENDING',
  rejected = 'REJECTED'
}

export enum UpdateStatus {
  completed = 'COMPLETED',
  rejected = 'REJECTED',
}

export enum userBusinessRoles {
  ADMIN = 'ADMIN',
  OPERATIONS = 'OPERATIONS',
  ANALYST = 'ANALYST',
  DEVELOPER = 'DEVELOPER',
  COMPLIANCE = 'COMPLIANCE',
  CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT'
}

export const optionsPeriod = [
  { label: 'Time Period: All Time', value: '1 month' },
  { label: '24 hours', value: '24 hours' },
  { label: '7 days', value: '7 days' },
  { label: '30 days', value: '30 days' }
]

export enum TransacctionStatus {
  expired = 'expired',
  pending = 'pending',
  active = 'active',
  cancelled = 'cancelled',
  completed = 'completed',
  failed = 'failed',
}

export const optionsStatus: any = {
  kyc: [
    { label: 'Status All', value: null },
    { label: 'Approved', value: true },
    { label: 'Rejected', value: false },
    //      { label: 'Sent', value: 'sent' },
    { label: 'Pending', value: null },
    /*       { label: 'Failed', value: 'failed' },
          { label: 'KycSend', value: 'kycSend' },
          { label: 'Declined', value: 'declined' },
          { label: 'Review', value: 'review' },
          { label: 'Unknown', value: 'unknown' }, */
  ],
  out: [
    { label: 'Status All', value: null },
    { label: 'Processed', value: 'PROCESSED' },
    { label: 'Rejected', value: 'REJECTED' },
    { label: 'Pending', value: 'PENDING' },
  ],
  in: [
    { label: 'Status All', value: null },
    { label: 'Expired', value: 'expired' },
    { label: 'Completed', value: 'completed' },
    { label: 'Pending', value: 'pending' },
    { label: 'Active', value: 'active' },
    { label: 'Cancelled', value: 'cancelled' },
    { label: 'Failed', value: 'failed' },
  ]
}

export const kycStatus: any = {
  'null': ['Pending', 'bg-[#ECECEC]', 'text-[#424242]', 'border-gray-500'],
  'true': ['Approved', 'bg-[#C7F6E2]', 'text-[#237253]', 'border-[#008F31]'],
  'false': ['Rejected', 'bg-[#FFABAB]', 'text-[#A30808]', 'border-[#A30808]']
}